import { useEffect, useState } from 'react';

export default function Home() {
  const [glowIntensity, setGlowIntensity] = useState(0.6);

  useEffect(() => {
    const interval = setInterval(() => {
      setGlowIntensity(prev => {
        const next = prev + 0.02;
        return next > 1 ? 0.6 : next;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#0a0a0a] flex items-center justify-center overflow-hidden">
      {/* Cinematic Fire Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c75ab640bc7c46453d4beb01b2914ed8.jpg')`
        }}
      />
      
      {/* Dark Overlay with Animated Glow */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/85 transition-opacity duration-300"
        style={{ opacity: glowIntensity }}
      />
      
      {/* Subtle Vignette */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/30 to-black/60" />

      {/* Content Container */}
      <div className="relative z-10 w-full max-w-4xl px-8 text-center">
        
        {/* Logo Section */}
        <div className="mb-12">
          <img 
            src="https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/f6e024d767fdcd15404b5441bd592d04.png" 
            alt="Flame & Fold Logo" 
            className="w-full max-w-md mx-auto mb-8 object-contain"
          />
          <p className="text-[#d4af37] text-lg md:text-xl tracking-widest uppercase font-light">
            Open Fire Mediterranean Kitchen
          </p>
        </div>

        {/* Coming Soon Statement */}
        <div className="mb-10">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-6 font-light tracking-wide">
            Coming Soon
          </h2>
          <p className="text-[#d4af37] text-base md:text-lg italic font-light tracking-wide mb-8">
            "Taste the Fire. Feel the Fold."
          </p>
        </div>

        {/* Premium Description */}
        <div className="mb-12">
          <p className="text-gray-300 text-base md:text-lg font-light leading-relaxed max-w-2xl mx-auto">
            A new fire-forward Mediterranean experience is arriving soon.
          </p>
        </div>

        {/* Divider */}
        <div className="w-32 h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent mx-auto mb-12" />

        {/* Contact Section */}
        <div className="flex flex-col items-center gap-6">
          <a 
            href="mailto:contact@flameandfold.com" 
            className="text-gray-400 hover:text-[#d4af37] transition-colors duration-300 text-sm font-light tracking-wide cursor-pointer"
          >
            contact@flameandfold.com
          </a>

          {/* Social Icons */}
          <div className="flex items-center gap-6">
            <a 
              href="https://www.facebook.com/flameandfoldus/" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="w-5 h-5 flex items-center justify-center text-white/70 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a 
              href="https://instagram.com/flameandfoldus" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="w-5 h-5 flex items-center justify-center text-white/70 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a 
              href="https://twitter.com/flameandfoldus" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="w-5 h-5 flex items-center justify-center text-white/70 hover:text-[#d4af37] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}